import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';
import { withRouter } from 'react-router-dom';

import Button from '../../../../components/Buttons/Button';
import { H1, Paragraph } from '../../../../components/Text/Text';
import noEventsIcon from '../../../../assets/images/icons/no-events.svg';
import Style from '../../../../styles/common';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

const Content = styled('div')`
  text-align: center;
`;

const Image = styled('img')`
  width: 80px;
`;

const Heading = styled(H1)`
  margin-top: ${Style.SPACING.L};
`;

const Message = styled(Paragraph)`
  margin: ${Style.SPACING.L} 0;
`;

function EmptyManageEvents(props) {
  return (
    <Container>
      <Content>
        <Image src={noEventsIcon}/>
        <Heading>You haven't created any events yet</Heading>
        <Message>
          This would be a great time to create your first event!
        </Message>
        <Button onClick={navigateToCreateEvent}>
          Go to create event
        </Button>
      </Content>
    </Container>
  );

  function navigateToCreateEvent() {
    props.history.push('/create-event');
  }
}

EmptyManageEvents.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withRouter(EmptyManageEvents);



// WEBPACK FOOTER //
// ./src/views/ManageEvents/ManageEventsBody/EmptyManageEvents/EmptyManageEvents.js